import utils from '../utils';

export const getProxyServicePath = (hostConfig) => {
  return (utils.isLocalHost() && hostConfig.local)
    || `https://${window.location.hostname}/${hostConfig.production}`;
};

export const getGetRequestInit = (token) => {
  const headers = getHeaders(token);

  return {
    method: 'GET',
    headers,
  };
};

export const getPostRequestInit = (body, token) => {
  const headers = getHeaders(token);

  return {
    method: 'POST',
    body: JSON.stringify(body),
    headers,
  };
};

export const deleteRequestInit = (token) => {
  const headers = getHeaders(token);

  return {
    method: 'DELETE',
    headers,
  };
};

export const retrieveData = async (url, requestInit) => {
  const response = await fetch(url, requestInit);

  if (!response.ok) {
    throw response;
  }

  return await response.json();
};

export const retrieveTextData = async (url, requestInit) => {
  const response = await fetch(url, requestInit);

  if (!response.ok) {
    throw response;
  }

  return await response.text();
};

const getHeaders = (token) => {
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  };
};
